import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [], // { productId, shopId, name, price, image, quantity, variants }
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { productId, shopId, name, price, image, quantity = 1, variants } = action.payload;
      const existing = state.items.find(
        (item) =>
          item.productId === productId && JSON.stringify(item.variants) === JSON.stringify(variants)
      );
      if (existing) {
        existing.quantity += quantity;
      } else {
        state.items.push({ productId, shopId, name, price, image, quantity, variants });
      }
    },
    removeFromCart: (state, action) => {
      state.items = state.items.filter(
        (item) =>
          item.productId !== action.payload.productId ||
          JSON.stringify(item.variants) !== JSON.stringify(action.payload.variants)
      );
    },
    updateQuantity: (state, action) => {
      const { productId, quantity, variants } = action.payload;
      const item = state.items.find(
        (item) =>
          item.productId === productId && JSON.stringify(item.variants) === JSON.stringify(variants)
      );
      if (item && quantity > 0) {
        item.quantity = quantity;
      }
    },
    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
